export class ServerConstants {

  //Command Names

  public static CREATE_TLD_COMMAND = 'CreateTopLevelDomainCommand';

  public static UPDATE_CHANGE_REQUEST_COMMAND = 'UpdateChangeRequestCommand';

  public static TRANSFER_TLD_COMMAND = 'TransferTopLevelDomainCommand';

  public static PERFORM_WORKFLOW_ACTION_COMMAND = 'PerformWorkflowActionCommand';

  public static ASSIGN_CHANGE_REQUEST_COMMAND = 'AssignChangeRequestCommand';

  public static UPDATE_CHANGE_REQUEST_ATTRIBUTES_COMMAND = 'UpdateChangeRequestAttributesCommand';

  public static RESEND_CONTACT_NOTIFICATION_COMMAND = 'ResendContactNotificationCommand';

  public static REVOKE_TLD_COMMAND = 'RevokeTopLevelDomainCommand';

  public static CHANGE_PASSWORD_COMMAND = 'ChangePasswordCommand';

  public static UPDATE_USER_ACCOUNT_SETTINGS_COMMAND = 'UpdateUserAccountSettingsCommand';

  //Server Field Names
  public static SPONSORING_FIELD_NAME = 'organization';
  public static ADMINISTRATIVE_FIELD_NAME = 'administrative';
  public static TECHNICAL_FIELD_NAME = 'technical';
  public static NAME_SERVERS_FIELD_NAME = 'nameServer';
  public static TRUST_ANCHORS_FIELD_NAME = 'trustAnchor';
  public static WHOIS_FIELD_NAME = 'whois';
  public static REGISTRYURL_FIELD_NAME = 'registryUrl';
  public static RDAP_SERVER_FIELD_NAME = 'rdapServer';
  public static ALL_NAME_SERVERS_FIELD_NAME = 'allNameServers';
  public static ALL_TRUST_ANCHORS_FIELD_NAME = 'allTrustAnchors';
  public static ALL_RDAP_SERVERS_FIELD_NAME = 'allRdapServers';
  public static LOCK_FIELD_NAME = 'locks';
  public static LAST_UPDATE_FIELD_NAME = 'lastUpdated';
  public static AUTH_POLICY_FIELD_NAME = 'authPolicy';
  public static AUTH_POLICY_USERS_FIELD_NAME = 'allPolicyUsers';
  public static META_DATA_FIELD_NAME = 'metadata';
}
